import React from 'react'
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import * as adminActions from '../actions/admin';
import {
    Chart,
    ChartArea,
    ChartSeries,
    ChartTitle,
    ChartSeriesItem,
    ChartLegend,
    ChartSeriesLabels,
    ChartCategoryAxis,
    ChartCategoryAxisItem,
    ChartValueAxis,
    ChartValueAxisItem,
    ChartTooltip
} from '@progress/kendo-react-charts';


const SharedTooltip = (props) => {
    const { data, points } = props;

    return (
        <div style={{padding: '4px 2px', minWidth: 160}}>
            <div style={{fontWeight: 700, marginBottom: 6, borderBottom: '1px solid rgba(255,255,255,0.2)', paddingBottom: 4}}>
                {data.company}
            </div>
            {points.map((point, i) => (
                <div key={i} style={{display: 'flex', justifyContent: 'space-between', gap: 12, fontSize: 12}}>
                    <span style={{color: point.series.color}}>{point.series.name}</span>
                    <span style={{fontWeight: 600}}>{point.value}</span>
                </div>
            ))}
        </div>
    );
};

const sharedTooltipRender = (context) => (<SharedTooltip {...context} />);

class RegisterDashboardForm extends React.Component {

    componentDidMount = () => {
        this.props.actions.loadHomeStats().then(() => {
            if (this.props.homeStats.generalStats) {
                this.props.onWeekLoaded(this.props.homeStats.generalStats.currentWeek);
                this.props.actions.loadHomeStats(this.props.homeStats.generalStats.currentWeek);
            }
        });
    }

    componentDidUpdate = (prevProps) => {
        if (prevProps.week !== this.props.week) {
            this.props.actions.loadHomeStats(this.props.week);
        }
    }


    render()  {

        let  ChartContainer4 = null, ChartContainer5 = null, ChartContainer6 = null
        
        if(this.props.homeStats){
            
            let SignInByLocation = this.props.homeStats.signInByLocations ? this.props.homeStats.signInByLocations : [],
            SignInByCompany = this.props.homeStats.signInByCompanies ? this.props.homeStats.signInByCompanies : [],
            LiveAndTravelTime = this.props.homeStats.liveAndTravelTime ? this.props.homeStats.liveAndTravelTime : [];

            ChartContainer4 = () => (
                <Chart pannable={{ lock: 'y' }} zoomable={{ mousewheel: { lock: 'y' }, selection: { lock: 'y' } }}>
                    <ChartLegend position="bottom" />
                    <ChartArea background="#272c33" height="350" />
                    <ChartValueAxis>
                        <ChartValueAxisItem name={'signIns'} title={{text:'No of Sign Ins'}} max={Math.max.apply(Math, SignInByCompany.map(x => x.signIns)) + 3} />
                        <ChartValueAxisItem name={'hours'} title={{text:'Sign In Hours'}} max={Math.max.apply(Math, SignInByCompany.map(x => x.signInHours)) + 10} />
                    </ChartValueAxis>
                    <ChartCategoryAxis>
                        <ChartCategoryAxisItem title={{text:'Companies'}} categories={SignInByCompany.map(x => x.company.substring(0,2))} axisCrossingValue={[0, SignInByCompany.length]} />
                    </ChartCategoryAxis>
                    <ChartSeries>
                        <ChartSeriesItem axis={'signIns'} type="column" data={SignInByCompany.map(x => x.signIns)} name="Number of Sign Ins" />
                        <ChartSeriesItem axis={'hours'} type="line" data={SignInByCompany.map(x => x.signInHours)} name="Sign In Hours" />
                    </ChartSeries>
                    <ChartTooltip shared={true} render={(props) => { props.data = SignInByCompany[props.points[0].categoryIndex]; return sharedTooltipRender(props) } } />
                </Chart>
            )
        
            ChartContainer5 = () => (

                <Chart pannable={{ lock: 'y' }} zoomable={{ mousewheel: { lock: 'y' }, selection: { lock: 'y' } }}>
                    <ChartArea background="#272c33" height="400" />
                    <ChartLegend position="bottom" />
                    <ChartSeries>
                    <ChartSeriesItem type="pie" data={SignInByLocation} field="signIns" categoryField="location">
                        <ChartSeriesLabels />
                    </ChartSeriesItem>
                    </ChartSeries>
                </Chart>

            )
    
            ChartContainer6 = () => (

                <Chart pannable={{ lock: 'y' }} zoomable={{ mousewheel: { lock: 'y' }, selection: { lock: 'y' } }}>
                    <ChartLegend position="bottom" />
                    <ChartArea  background="#272c33" height="350" />
                    <ChartSeries>
                    <ChartSeriesItem type="pie" data={LiveAndTravelTime} field="total" categoryField="category">
                        <ChartSeriesLabels />
                    </ChartSeriesItem>
                    </ChartSeries>
                </Chart>
            )
        
        }

        if (this.props.loading) {
            return (
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '60px 0', color: '#a6b0cf'}}>
                    <div className="dash-spinner" />
                    <div style={{marginTop: 16, fontSize: 13}}>Loading dashboard...</div>
                </div>
            );
        }

        return (

            <div>

                <div className="dash-section-banner">
                    <span className="mdi mdi-account-group dash-section-icon"></span> Register Statistics
                </div>
                <div className='row'>

                <div className="col-lg-3 col-md-6">
                    <div className="card dash-stat-card">
                        <div className="card-body">
                            <div className="row align-items-center">
                                <div className="col-8">
                                    <h2 style={{color: 'var(--amber-primary)'}}>{this.props.homeStats.generalStats && this.props.homeStats.generalStats.numberOfSignIns} </h2>
                                    <h6>Number of Sign Ins</h6>
                                </div>
                                <div className="col-4 text-center">
                                    <span className="mdi mdi-account-multiple dash-stat-icon"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6">
                    <div className="card dash-stat-card">
                        <div className="card-body">
                            <div className="row align-items-center">
                                <div className="col-8">
                                    <h2 style={{color: 'var(--amber-primary)'}}>{this.props.homeStats.generalStats && this.props.homeStats.generalStats.workingHours} </h2>
                                    <h6>Working Hours</h6>
                                </div>
                                <div className="col-4 text-center">
                                    <span className="mdi mdi-clock-outline dash-stat-icon"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6">
                    <div className="card dash-stat-card">
                        <div className="card-body">
                            <div className="row align-items-center">
                                <div className="col-8">
                                    <h2 style={{color: 'var(--amber-primary)'}}>{this.props.homeStats.generalStats && this.props.homeStats.generalStats.travelHours} </h2>
                                    <h6>Travel Hours</h6>
                                </div>
                                <div className="col-4 text-center">
                                    <span className="mdi mdi-car-outline dash-stat-icon"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6">
                    <div className="card dash-stat-card">
                        <div className="card-body">
                            <div className="row align-items-center">
                                <div className="col-8">
                                    <h2 style={{color: 'var(--amber-primary)'}}>{this.props.homeStats.generalStats && this.props.homeStats.generalStats.totalHours}</h2>
                                    <h6>Total Hours</h6>
                                </div>
                                <div className="col-4 text-center">
                                    <span className="mdi mdi-sigma dash-stat-icon"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-lg-12 col-md-12">
                    <div className="card">
                        <div className="card-header ctrl-log-card-header">
                            <span className="mdi mdi-chart-bar ctrl-log-card-icon"></span>
                            <h5 className="mb-0">Sign In By Company</h5>
                        </div>
                        <div className="card-body" style={{padding: 0}}>
                            <div className="chart-scroll-wrapper">
                                <div className="chart-scroll-inner" style={{minWidth: window.innerWidth <= 767 ? Math.max(600, ((this.props.homeStats.signInByCompanies || []).length) * 22) : 'auto'}}>
                                    <ChartContainer4 />
                                </div>
                                <div className="chart-scroll-fade" />
                            </div>
                            <div className="chart-scroll-hint">← swipe to explore · tap bar for company name →</div>
                        </div>
                    </div>
                </div>
                
            </div>

            <div className="row">

                <div className="col-lg-6 col-md-6">
                    <div className="card">
                        <div className="card-header ctrl-log-card-header">
                            <span className="mdi mdi-chart-pie ctrl-log-card-icon"></span>
                            <h5 className="mb-0">Live vs Travel</h5>
                        </div>
                        <div className="card-body">
                        
                            <ChartContainer6 />

                        </div>
                    </div>
                </div>
            
                <div className="col-lg-6 col-md-6">
                    <div className="card">
                        <div className="card-header ctrl-log-card-header">
                            <span className="mdi mdi-map-marker-radius-outline ctrl-log-card-icon"></span>
                            <h5 className="mb-0">Sign In By Location</h5>
                        </div>
                        <div className="card-body">
                        
                            <ChartContainer5 />

                        </div>
                    </div>
                </div>
            </div>

            </div>
        )

    }

  }



function mapStateToProps(state, ownProps) {

    return {
        homeStats: state.homeStats,
        loading: state.ajaxCallsInProgress > 0
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(adminActions, dispatch)
    };
}


export default connect(mapStateToProps, mapDispatchToProps) (RegisterDashboardForm);